// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-response {
    flex-grow: 1;
}

.customer-info-table,
.quote-details-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    border-top: 2px solid #333;
}

.customer-info-table th, .customer-info-table td,
.quote-details-table th, .quote-details-table td {
    border-bottom: 1px solid #ddd;
    padding: 15px;
    text-align: left;
}

.customer-info-table th,
.quote-details-table th {
    background-color: #f8f9fa;
    font-weight: bold;
    width: 150px;
}

.quote-items-list {
    margin-top: 30px;
}

.quote-item-card {
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 20px;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 15px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #ddd;
}

.status-badge {
    margin-left: auto;
    background-color: #f0f0f0;
    padding: 8px 12px;
    border-radius: 5px;
    font-size: 14px;
}

.status-badge.pending {
    background-color: #fff;
    border: 1px solid #e84118;
    color: #e84118;
}

.status-badge span {
    display: block;
    font-size: 12px;
    color: #888;
    margin-top: 5px;
}

.card-body {
    display: flex;
    padding: 20px;
    gap: 20px;
}

.card-body img {
    width: 100px;
    height: 60px;
    object-fit: cover;
}

.item-details {
    flex-grow: 1;
}

.item-price {
    margin-left: auto;
    text-align: right;
}

.shipping-note {
    border: 1px solid #ddd;
    padding: 20px;
    margin-bottom: 30px;
    background-color: #f8f9fa;
}

/* 추가요청사항 섹션 스타일 */
.additional-request-section {
    margin-bottom: 30px;
    padding: 20px;
    background-color: #fff8e1;
    border-radius: 5px;
    border-left: 4px solid #ff9800;
}

.additional-request-section h3 {
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
    font-size: 16px;
}

.additional-request-content {
    background-color: white;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #ddd;
}

.additional-request-content p {
    margin: 0;
    color: #666;
    line-height: 1.5;
    font-weight: normal;
}

.response-attachment-section,
.admin-memo-section {
    margin-bottom: 30px;
}

.attachment-row {
    display: flex;
    align-items: center;
    gap: 15px;
    border: 1px solid #ddd;
    padding: 20px;
}

.attachment-row button {
    padding: 8px 15px;
    background-color: #e9ecef;
    border: 1px solid #ccc;
    cursor: pointer;
    border-radius: 5px;
}

.admin-memo-section textarea {
    width: 100%;
    height: 100px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: vertical;
}

/* 주문 제작 견적 섹션 */
.custom-order-section {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 20px;
    overflow: hidden;
}

.custom-order-header {
    background-color: #f8f9fa;
    padding: 20px;
    border-bottom: 1px solid #ddd;
    text-align: center;
}

.custom-order-header h3 {
    margin: 0 0 10px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
}

.custom-order-header p {
    margin: 0;
    font-size: 14px;
    color: #666;
}

.custom-order-info {
    padding: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
}

.info-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 6px;
}

.info-item .label {
    font-size: 12px;
    color: #888;
    margin-bottom: 5px;
    font-weight: 500;
}

.info-item .value {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

/* 고객 첨부파일 스타일 */
.customer-files {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.customer-files h4 {
    margin: 0 0 15px 0;
    font-size: 16px;
    color: #333;
    font-weight: 600;
}

.customer-file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    margin-bottom: 10px;
}

/* 기존 첨부파일 및 답변 스타일 */
.existing-attachment,
.existing-reply {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
}

.existing-attachment h4,
.existing-reply h4 {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #666;
    font-weight: 600;
}

.existing-file-item {
    display: flex;
    align-items: center;
}

/* 고객 첨부파일 섹션 추가 스타일 */
.customer-files-section {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f9f9f9;
}

.customer-files-section h3 {
    margin: 0 0 15px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.btn-download-small, .btn-preview-small {
    padding: 4px 8px;
    font-size: 12px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 5px;
    transition: background-color 0.2s;
}

.btn-download-small {
    background-color: #007bff;
    color: white;
}

.btn-download-small:hover {
    background-color: #0056b3;
}

.btn-preview-small {
    background-color: #28a745;
    color: white;
}

.btn-preview-small:hover {
    background-color: #1e7e34;
}

.file-actions {
    display: flex;
    gap: 5px;
}

.existing-reply-content {
    padding: 10px;
    background-color: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.existing-reply-content p {
    margin: 0;
    line-height: 1.6;
    color: #333;
}

.attachment-upload-section h4 {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #333;
    font-weight: 600;
}

.file-info {
    font-size: 14px;
    color: #333;
    flex: 1 1;
}

.file-actions {
    display: flex;
    gap: 8px;
}

.btn-download-small, .btn-preview-small {
    padding: 6px 12px;
    font-size: 12px;
    border: 1px solid #007bff;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-download-small {
    background-color: #007bff;
    color: white;
}

.btn-download-small:hover {
    background-color: #0056b3;
}

.btn-preview-small {
    background-color: white;
    color: #007bff;
}

.btn-preview-small:hover {
    background-color: #f8f9fa;
}

.customer-message p {
    line-height: 1.6;
    margin: 0;
}

.total-summary-section {
    margin-top: 30px;
    margin-bottom: 30px;
}

/* 폼 액션 버튼 스타일 */
.form-actions {
    display: flex;
    flex-direction: row-reverse;
    gap: 15px;
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #e0e0e0;
}

.form-actions button {
    width: 100%;
    padding: 15px 20px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.form-actions .btn-secondary {
    background-color: #ffffff;
    color: #333333;
    border: 2px solid #333333;
}

.form-actions .btn-secondary:hover {
    background-color: #333333;
    color: #ffffff;
}

.form-actions .btn-primary {
    background-color: #333333;
    color: #ffffff;
}

.form-actions .btn-primary:hover {
    background-color: #555555;
}

.form-actions .btn-primary:disabled {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
}

.btn-icon {
    font-size: 14px;
    font-weight: bold;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .form-actions {
        gap: 12px;
        margin-top: 30px;
        padding-top: 20px;
    }
    
    .form-actions button {
        padding: 12px 16px;
        font-size: 15px;
    }
    .customer-info-table th,
    .quote-details-table th {
        width: 120px;
    }

    .card-body {
        flex-direction: column;
        align-items: flex-start;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .customer-info-table tr,
    .quote-details-table tr {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        border: none;
    }

    .customer-info-table th, .customer-info-table td,
    .quote-details-table th, .quote-details-table td {
        display: block;
        width: 100%;
        box-sizing: border-box;
        border: none;
        padding: 5px 0;
    }
    
    .customer-info-table th,
    .quote-details-table th {
        background-color: transparent;
        font-weight: bold;
    }
    
    .card-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .status-badge {
        margin-left: 0;
        margin-top: 10px;
    }
    
    .attachment-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .custom-order-info {
        grid-template-columns: 1fr;
        gap: 15px;
    }
    
    .customer-file-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .file-actions {
        width: 100%;
        justify-content: flex-start;
    }
    
    .form-actions {
        flex-direction: row;
        gap: 10px;
        margin-top: 20px;
        padding-top: 15px;
    }
    
    .form-actions button {
        flex: 1 1;
        min-width: 120px;
        max-width: none;
        padding: 12px 16px;
        font-size: 14px;
    }
} 

/* 매우 작은 화면에서는 버튼 세로 스택 */
@media (max-width: 480px) {
    .form-actions {
        flex-direction: column;
        gap: 10px;
    }
    
    .form-actions button {
        width: 100%;
        max-width: none;
    }
}

/* 배송지 정보 스타일 */ `, "",{"version":3,"sources":["webpack://./src/admin/css/QuotationResponsePage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;;IAEI,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;;IAEI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAO;AACX;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI;QACI,SAAS;QACT,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;;QAEI,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA,mBAAmB;AACnB;IACI;;QAEI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;IAChB;;IAEA;;QAEI,cAAc;QACd,WAAW;QACX,sBAAsB;QACtB,YAAY;QACZ,cAAc;IAClB;;IAEA;;QAEI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA,yBAAyB;AACzB;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,eAAe","sourcesContent":[".admin-content-response {\n    flex-grow: 1;\n}\n\n.customer-info-table,\n.quote-details-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n    border-top: 2px solid #333;\n}\n\n.customer-info-table th, .customer-info-table td,\n.quote-details-table th, .quote-details-table td {\n    border-bottom: 1px solid #ddd;\n    padding: 15px;\n    text-align: left;\n}\n\n.customer-info-table th,\n.quote-details-table th {\n    background-color: #f8f9fa;\n    font-weight: bold;\n    width: 150px;\n}\n\n.quote-items-list {\n    margin-top: 30px;\n}\n\n.quote-item-card {\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.card-header {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #ddd;\n}\n\n.status-badge {\n    margin-left: auto;\n    background-color: #f0f0f0;\n    padding: 8px 12px;\n    border-radius: 5px;\n    font-size: 14px;\n}\n\n.status-badge.pending {\n    background-color: #fff;\n    border: 1px solid #e84118;\n    color: #e84118;\n}\n\n.status-badge span {\n    display: block;\n    font-size: 12px;\n    color: #888;\n    margin-top: 5px;\n}\n\n.card-body {\n    display: flex;\n    padding: 20px;\n    gap: 20px;\n}\n\n.card-body img {\n    width: 100px;\n    height: 60px;\n    object-fit: cover;\n}\n\n.item-details {\n    flex-grow: 1;\n}\n\n.item-price {\n    margin-left: auto;\n    text-align: right;\n}\n\n.shipping-note {\n    border: 1px solid #ddd;\n    padding: 20px;\n    margin-bottom: 30px;\n    background-color: #f8f9fa;\n}\n\n/* 추가요청사항 섹션 스타일 */\n.additional-request-section {\n    margin-bottom: 30px;\n    padding: 20px;\n    background-color: #fff8e1;\n    border-radius: 5px;\n    border-left: 4px solid #ff9800;\n}\n\n.additional-request-section h3 {\n    font-weight: bold;\n    margin-bottom: 15px;\n    color: #333;\n    font-size: 16px;\n}\n\n.additional-request-content {\n    background-color: white;\n    padding: 15px;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n}\n\n.additional-request-content p {\n    margin: 0;\n    color: #666;\n    line-height: 1.5;\n    font-weight: normal;\n}\n\n.response-attachment-section,\n.admin-memo-section {\n    margin-bottom: 30px;\n}\n\n.attachment-row {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    border: 1px solid #ddd;\n    padding: 20px;\n}\n\n.attachment-row button {\n    padding: 8px 15px;\n    background-color: #e9ecef;\n    border: 1px solid #ccc;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n.admin-memo-section textarea {\n    width: 100%;\n    height: 100px;\n    padding: 15px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    resize: vertical;\n}\n\n/* 주문 제작 견적 섹션 */\n.custom-order-section {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    overflow: hidden;\n}\n\n.custom-order-header {\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-bottom: 1px solid #ddd;\n    text-align: center;\n}\n\n.custom-order-header h3 {\n    margin: 0 0 10px 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #333;\n}\n\n.custom-order-header p {\n    margin: 0;\n    font-size: 14px;\n    color: #666;\n}\n\n.custom-order-info {\n    padding: 20px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 20px;\n}\n\n.info-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n}\n\n.info-item .label {\n    font-size: 12px;\n    color: #888;\n    margin-bottom: 5px;\n    font-weight: 500;\n}\n\n.info-item .value {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n}\n\n/* 고객 첨부파일 스타일 */\n.customer-files {\n    margin-top: 20px;\n    padding-top: 20px;\n    border-top: 1px solid #eee;\n}\n\n.customer-files h4 {\n    margin: 0 0 15px 0;\n    font-size: 16px;\n    color: #333;\n    font-weight: 600;\n}\n\n.customer-file-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    margin-bottom: 10px;\n}\n\n/* 기존 첨부파일 및 답변 스타일 */\n.existing-attachment,\n.existing-reply {\n    margin-bottom: 20px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n}\n\n.existing-attachment h4,\n.existing-reply h4 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    color: #666;\n    font-weight: 600;\n}\n\n.existing-file-item {\n    display: flex;\n    align-items: center;\n}\n\n/* 고객 첨부파일 섹션 추가 스타일 */\n.customer-files-section {\n    margin-bottom: 30px;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n}\n\n.customer-files-section h3 {\n    margin: 0 0 15px 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.btn-download-small, .btn-preview-small {\n    padding: 4px 8px;\n    font-size: 12px;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    margin-left: 5px;\n    transition: background-color 0.2s;\n}\n\n.btn-download-small {\n    background-color: #007bff;\n    color: white;\n}\n\n.btn-download-small:hover {\n    background-color: #0056b3;\n}\n\n.btn-preview-small {\n    background-color: #28a745;\n    color: white;\n}\n\n.btn-preview-small:hover {\n    background-color: #1e7e34;\n}\n\n.file-actions {\n    display: flex;\n    gap: 5px;\n}\n\n.existing-reply-content {\n    padding: 10px;\n    background-color: white;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n}\n\n.existing-reply-content p {\n    margin: 0;\n    line-height: 1.6;\n    color: #333;\n}\n\n.attachment-upload-section h4 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    color: #333;\n    font-weight: 600;\n}\n\n.file-info {\n    font-size: 14px;\n    color: #333;\n    flex: 1;\n}\n\n.file-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.btn-download-small, .btn-preview-small {\n    padding: 6px 12px;\n    font-size: 12px;\n    border: 1px solid #007bff;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-download-small {\n    background-color: #007bff;\n    color: white;\n}\n\n.btn-download-small:hover {\n    background-color: #0056b3;\n}\n\n.btn-preview-small {\n    background-color: white;\n    color: #007bff;\n}\n\n.btn-preview-small:hover {\n    background-color: #f8f9fa;\n}\n\n.customer-message p {\n    line-height: 1.6;\n    margin: 0;\n}\n\n.total-summary-section {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n/* 폼 액션 버튼 스타일 */\n.form-actions {\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 15px;\n    margin-top: 40px;\n    padding-top: 30px;\n    border-top: 2px solid #e0e0e0;\n}\n\n.form-actions button {\n    width: 100%;\n    padding: 15px 20px;\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.form-actions .btn-secondary {\n    background-color: #ffffff;\n    color: #333333;\n    border: 2px solid #333333;\n}\n\n.form-actions .btn-secondary:hover {\n    background-color: #333333;\n    color: #ffffff;\n}\n\n.form-actions .btn-primary {\n    background-color: #333333;\n    color: #ffffff;\n}\n\n.form-actions .btn-primary:hover {\n    background-color: #555555;\n}\n\n.form-actions .btn-primary:disabled {\n    background-color: #cccccc;\n    color: #666666;\n    cursor: not-allowed;\n}\n\n.btn-icon {\n    font-size: 14px;\n    font-weight: bold;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .form-actions {\n        gap: 12px;\n        margin-top: 30px;\n        padding-top: 20px;\n    }\n    \n    .form-actions button {\n        padding: 12px 16px;\n        font-size: 15px;\n    }\n    .customer-info-table th,\n    .quote-details-table th {\n        width: 120px;\n    }\n\n    .card-body {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .customer-info-table tr,\n    .quote-details-table tr {\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 10px;\n        border: none;\n    }\n\n    .customer-info-table th, .customer-info-table td,\n    .quote-details-table th, .quote-details-table td {\n        display: block;\n        width: 100%;\n        box-sizing: border-box;\n        border: none;\n        padding: 5px 0;\n    }\n    \n    .customer-info-table th,\n    .quote-details-table th {\n        background-color: transparent;\n        font-weight: bold;\n    }\n    \n    .card-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .status-badge {\n        margin-left: 0;\n        margin-top: 10px;\n    }\n    \n    .attachment-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .custom-order-info {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n    \n    .customer-file-item {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .file-actions {\n        width: 100%;\n        justify-content: flex-start;\n    }\n    \n    .form-actions {\n        flex-direction: row;\n        gap: 10px;\n        margin-top: 20px;\n        padding-top: 15px;\n    }\n    \n    .form-actions button {\n        flex: 1;\n        min-width: 120px;\n        max-width: none;\n        padding: 12px 16px;\n        font-size: 14px;\n    }\n} \n\n/* 매우 작은 화면에서는 버튼 세로 스택 */\n@media (max-width: 480px) {\n    .form-actions {\n        flex-direction: column;\n        gap: 10px;\n    }\n    \n    .form-actions button {\n        width: 100%;\n        max-width: none;\n    }\n}\n\n/* 배송지 정보 스타일 */ "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
